<template>
    <div class="my-3">
        <div class="d-flex w-100 justify-content-end" v-if="type === 'open' && showEditAnswer"> 
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret right>
                <template v-slot:button-content >
                    <b-icon icon="three-dots-vertical"></b-icon>
                </template>
                <b-dropdown-item href="#" @click="showFseModal">{{trans('courses.edit')}}</b-dropdown-item>
            </b-dropdown>
        </div>
        
        <h6 :class="isDarkBg ? 'block-header' : ''" v-if="prompt.title">{{ prompt.title }}</h6> 
        <p :class="isDarkBg ? 'text-white' : 'text-muted'" v-if="prompt.subtitle">{{ prompt.subtitle }}</p>
        <p class="text-muted" v-if="text">{{ text }}</p>
        <div class="my-3">
            <full-screen-editor
                v-if="type === 'open'"
                :page-id="pageId"
                :prompt-id="promptId"
                :question="prompt.title"
                :text-content="hasSubmission ? prompt.submission[0].text : ''"
                :mood-content="getPromptMoodValue" 
                :key="promptId"
                @submit="updatePrompt"
                ref="fseModal"
                :moodDisabled="true"
            />
            <options-prompt
                :answers="prompt.answers"
                :id="pageId"
                :key="promptId"
                v-if="type === 'closed_single'"
                :currentOption="hasSubmission ? prompt.submission[0].closed_answer_id : notSelected"
                @optionSelected="updatePrompt"
            />
            <checkbox-prompt
                :answers="prompt.answers"
                :id="pageId"
                :key="promptId"
                v-if="type === 'closed_multiple'"
                :user-answers="hasSubmission ? prompt.submission.map(s => s.closed_answer_id) : []"
                @optionSelected="updatePrompt"
            />
            <rating-prompt
                :answers="prompt.answers"
                :id="pageId"
                :key="promptId"
                v-if="type === 'close_single_horizontal_group'"
                :currentOption="hasSubmission ? prompt.submission[0].closed_answer_id : notSelected"
                @optionSelected="updatePrompt"
            />
        </div>
    </div>
</template>

<script>
    import FullScreenEditor from "../FullScreenEditor";
    import OptionsPrompt from "./blocks/OptionsPrompt";
    import RatingPrompt from "./blocks/RatingPrompt";
    import CheckboxPrompt from "./blocks/CheckboxPrompt";
    import { mapGetters } from 'vuex';

    export default {
        name: "PromptContainer",
        components:{
            FullScreenEditor,
            OptionsPrompt,
            RatingPrompt,
            CheckboxPrompt,
        },
        props:{
            prompt: Object,
            promptId: String,
            pageId: String,
            moduleId: Number,
            courseId: Number,
            courseName: String,
            isAugmented: Boolean,
            isMission: String,
            type: String,
            isDarkBg: Boolean,
            text: String
        },
        data(){
            return{
                userPrompt: this.prompt,
                notSelected: -1
            }
        },
        methods:{
            showFseModal() {
                this.$refs.fseModal.showModal();
            },
            updatePrompt(data){
                const formData = {
                    text: data.text,
                    prompt_type: this.type,
                    answers: data.answers,
                    mood_id: this.moodValid(data.mood) ? data.mood : null
                }

                this.$axios.post(`/api/rest/programs/${this.courseId}/modules/${this.moduleId}/pages/${this.pageId}/prompt/${this.promptId}/submit`, formData)
                    .then(res=>{
                        //Prompt submitted successfully
                        trackEvent("Prompts", {
                            "prompt-type": this.type,
                            "prompt-id": this.promptId,
                            "page-id": this.pageId,
                            "module-id": this.moduleId,
                            "course-id": this.courseId,
                            "course-name": this.courseName,
                            "is-mission": this.isMission,
                            "is-augmented": this.isAugmented,
                            "mood-id":  this.moodValid(data.mood) ? data.mood : null,
                            "mood-icon": this.moodValid(data.mood) ? this.moodsList.moods.find((m) => m.id === data.mood).icon : null,
                            "mood-name": this.moodValid(data.mood) ? this.moodsList.moods.find((m) => m.id === data.mood).name : null
                        });
                    })
                    .catch(e=>{
                        console.log(e);
                    });

                if(Array.isArray(data.answers)){
                    this.userPrompt.submission = data.answers.map(answer => {return {closed_answer_id: answer}})
                }else{
                    this.userPrompt.submission = [{
                        text: data.answers,
                        closed_answer_id: data.answers,
                        mood: {
                            id: data.mood
                        }
                    }];
                }

                this.$emit('updatePrompt', this.userPrompt.submission);
            },
            moodValid(valueToCheck) {
                return [undefined,null,this.moodsList.notSelected].indexOf(valueToCheck)===-1;
            }
        },
        computed:{
            ...mapGetters({
                moodsList: 'moodsAndReactions/getMoodsList'
            }),
            getPromptMoodValue: function() {
                return this.hasSubmission && this.prompt.submission[0].mood && this.prompt.submission[0].mood.id ? this.prompt.submission[0].mood.id : null
            },
            hasSubmission: function() {
                return this.prompt.submission && this.prompt.submission.length>0;
            },
            showEditAnswer: function() {
                return this.hasSubmission && this.prompt.submission[0].text.length > 0
            }
        }
    }
</script>
